import React from 'react';

interface IReferenceElementProps {
  querySelector: string;
  key?: string;
}

// after TAB-ing the submit - focus on other element immediately
// tslint:disable-next-line: variable-name
const ReferenceToElement: React.FC<IReferenceElementProps> = ({ key = 'Tab', querySelector }) => {
  const handleSubmitKey = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === key) {
      const elementToBeReferenced: HTMLElement | null = document.querySelector(querySelector);
      if (elementToBeReferenced) {
        elementToBeReferenced.focus();
      }
    }
  };

  return <span onKeyUp={handleSubmitKey} tabIndex={0} />;
};

export default ReferenceToElement;
